import { Flex, UnorderedList, ListItem, Text } from "@chakra-ui/react";
import moment from "moment";
import { NotificationsContext } from "providers/notifications";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NoResults from "../NoResults";
import UserAvatar from "../UserAvatar";
import WidgetBox from "../WidgetBox/widget-box";

const UnreadMessages = () => {
    const { unread } = useContext(NotificationsContext);

    const [conversations, setConversations] = useState<{
        [key: string]: any[];
    }>({});

    useEffect(() => {
        const convos: {
            [key: string]: any[];
        } = {};
        unread.forEach((notification: any) => {
            if (!convos[notification.conversation]) {
                convos[notification.conversation] = [notification];
            } else {
                convos[notification.conversation] = [
                    notification,
                    ...convos[notification.conversation],
                ];
            }
        });
        setConversations(convos);
    }, [unread]);

    return (
        <WidgetBox title="Messages">
            {Object.keys(conversations).length > 0 ? (
                <UnorderedList
                    listStyleType="none"
                    p="0px"
                    m="0px"
                    maxH="400px"
                    mt="24px"
                >
                    {Object.keys(conversations).map((convo: string) => (
                        <ListItem
                            key={convo}
                            borderBottomWidth="1px"
                            borderBottomColor="gray.50"
                            _last={{
                                borderBottomWidth: "0px",
                                pb: "0px",
                            }}
                        >
                            <Link to={`/messages/${convo}`}>
                                <Flex py="10px" alignItems="center">
                                    <UserAvatar
                                        size="40px"
                                        mr="15px"
                                        user={
                                            conversations[convo][0].event
                                                .message.from
                                        }
                                    />
                                    <Flex flexDir="column" flexGrow="1">
                                        <Text
                                            fontSize="15px"
                                            fontWeight="500"
                                            lineHeight="20px"
                                        >
                                            {
                                                conversations[convo][0].event
                                                    .message.from.first_name
                                            }{" "}
                                            {
                                                conversations[convo][0].event
                                                    .message.from.last_name
                                            }
                                        </Text>
                                        <Flex
                                            flexGrow="1"
                                            // justifyContent="space-between"
                                            color="gray.200"
                                            fontSize="12px"
                                            alignItems="center"
                                            lineHeight="20px"
                                            fontWeight="500"
                                        >
                                            <Text
                                                noOfLines={1}
                                                color="black"
                                                fontWeight="500"
                                                fontSize="12px"
                                            >
                                                {conversations[convo].length ===
                                                1
                                                    ? conversations[convo][0]
                                                          .event.message.body
                                                    : `${conversations[convo].length} messages`}
                                            </Text>
                                        </Flex>
                                    </Flex>
                                    <Text fontSize="11px" whiteSpace="nowrap">
                                        {moment(
                                            conversations[convo][0].created_at
                                        ).fromNow()}
                                    </Text>
                                </Flex>
                            </Link>
                        </ListItem>
                    ))}
                </UnorderedList>
            ) : (
                <NoResults message="No new messages..." />
            )}
        </WidgetBox>
    );
};

export default UnreadMessages;
